import { Icon } from '../../../design-system/Icon'
import { useResponsive } from '@/screens/new-design/hooks'

export type PlayerRole = 'SB' | 'BB' | 'D' | 'hole' | 'chips' | 'pot'

interface PlayerRoleProps {
  role: PlayerRole
  size?: 'small' | 'medium' | 'big'
  useColoredBadge?: boolean
}

export const PlayerRole = ({ role, size = 'small', useColoredBadge = true }: PlayerRoleProps) => {
  const { verticalScale } = useResponsive()
  if (role === 'chips' || role === 'hole' || role === 'pot') return null

  const iconName = useColoredBadge ? 'BadgeColored' : 'Badge'

  const iconSize = getIconSize({ size, verticalScale, useColoredBadge })

  return <Icon name={`${iconName}--${role}`} size={iconSize} color={'Global/White'} />
}

type GetIconSizeArgs = {
  useColoredBadge: boolean
  size: 'small' | 'medium' | 'big'
  verticalScale: (n: number) => number
}
type GetIconSize = (args: GetIconSizeArgs) => [number, number] | number

const getIconSize: GetIconSize = ({ verticalScale, size, useColoredBadge = true }) => {
  if (useColoredBadge) {
    switch (size) {
      case 'big':
        return verticalScale(28)
      case 'medium':
        return verticalScale(24)
      default:
        return verticalScale(22)
    }
  }

  // Default
  switch (size) {
    case 'big':
      return [verticalScale(37), verticalScale(50)]
    case 'medium':
      return [verticalScale(24), verticalScale(30)]
    default:
      return [verticalScale(16), verticalScale(20)]
  }
}
